{
  "title": "Разрешить доступ к вашему местоположению?",
  "body": "Разрешив доступ к вашему местоположению, мы сможем убедиться, что вы прибыли на объект для регистрации",
  "disagree": "Отказать",
  "agree": "Разрешить"
}
